<template>
    <v-btn
        class="tw-mx-auto tw-w-max tw-text-xs tw-normal-case"
        color="primary"
        rounded="pill"
        size="small"
        >
        {{ $t('shared.seeMore') }}
    </v-btn>
</template>

<script setup lang="ts">

</script>

<style scoped></style>
